<template>
    <v-alert transition="scale-transition" :value="value" text color="info">
        <h3 class="text-h5 mb-4">
            Thank You!
        </h3>
        <div>
            <p>
                Your kindness and generosity is appreciated and directly helps many women.  Further you may also be gaining staking interest from your gift! <router-link :to="{ name: 'faq', query: { category: 'wishlist', id: '62f32f3cf5e74a0001f7077b' }}" class="text-caption no-decoration ml-2" style="text-decoration: none"><sup>(What?)</sup></router-link>
            </p>
            <p>
                Your blockchain transaction can be found here: <span v-html="$near.explorerTransactionLink($route, { showUrl: true, contractId })"></span>.
            </p>
        </div>

        <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>

        <v-row align="center" no-gutters>
            <v-col class="grow">
                Pectus firmamentum est nostra missio.
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="shrink">
                <v-btn @click="$emit('input', value)" color="info" outlined>
                    Okay
                </v-btn>
            </v-col>
        </v-row>
    </v-alert>
</template>
<script>
export default {
    name: 'BnftWishlistGiftReceiptAlert',
    props: {
        value: Boolean,
    },
    data() {
        return {
            contractId: process.env.VUE_APP_NEAR_WISHLIST_CONTRACT_ID
        }
    }
}
</script>
